import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import axios from "axios";
import { GoPencil } from "react-icons/go";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Bounce, toast } from "react-toastify";

const Navbar = () => {
  const [res, setRes] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("hiedberg_admin_token");

  const validationSchema = Yup.object().shape({
    buttonText: Yup.string().required("Button text is required"),
    buttonUrl: Yup.string()
      .url("Please add http or https in URL")
      .required("URL is required"),
  });
  const handleEditToggle = () => {
    setIsEditing(true);
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/navbar/get`
      );
      setRes(result.data.data);
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Error fetching:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSave = async (values) => {
    try {
      setLoading(true);
      const updateData = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/navbar/update`,
        {
          buttonText: values.buttonText,
          buttonUrl: values.buttonUrl,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (updateData?.data?.isSuccess) {
        const isButtonTextChanged = values.buttonText !== res.buttonText;
        const isButtonUrlChanged = values.buttonUrl !== res.buttonUrl;

        if (isButtonTextChanged || isButtonUrlChanged) {
          setRes({
            buttonText: values.buttonText,
            buttonUrl: values.buttonUrl,
          });
        }

        setIsEditing(false);
        toast.success("Navbar updated successfully", {
          position: "top-right",
          autoClose: 5000,
          pauseOnHover: true,
          transition: Bounce,
        });
      }
    } catch (err) {
      console.error("Error during save:", err);
      toast.error(err, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      {loading ? (
        <div className="flex justify-center py-10">
          <div className="h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="mt-5 space-y-4 overflow-auto pb-6">
          <Formik
            enableReinitialize
            initialValues={{
              buttonText: res?.buttonText || "",
              buttonUrl: res?.buttonUrl || "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSave}
          >
            {({ values, handleChange, errors, touched, resetForm }) => (
              <Form>
                <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                  <div className="flex items-center justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Navbar
                    </h3>
                    {isEditing ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setIsEditing(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={handleEditToggle}
                      />
                    )}
                  </div>
                  <div className="flex flex-col gap-y-4">
                    <TextField
                      label="Button Text"
                      name="buttonText"
                      variant="outlined"
                      size="small"
                      value={values.buttonText}
                      onChange={handleChange}
                      disabled={!isEditing}
                      error={touched.buttonText && Boolean(errors.buttonText)}
                      helperText={touched.buttonText && errors.buttonText}
                      slotProps={{ inputLabel: { shrink: true } }}
                    />
                    <TextField
                      label="Button URL"
                      name="buttonUrl"
                      variant="outlined"
                      size="small"
                      value={values.buttonUrl}
                      onChange={handleChange}
                      disabled={!isEditing}
                      error={touched.buttonUrl && Boolean(errors.buttonUrl)}
                      helperText={touched.buttonUrl && errors.buttonUrl}
                      slotProps={{ inputLabel: { shrink: true } }}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};
export default Navbar;
